import React, { useRef, useEffect } from "react";

const OBJ = {
	"bounce-in": "animate-bouce-in",
	"puff-in-center": "animate-puff-in-center",
	"background": "animate-background",
};

function MainIntersectProvider({ children, animate: ANIMATION_TYPE }) {
	const ref = useRef();

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					console.log("Intersecting 🚀");
					ref.current.className =
						ANIMATION_TYPE === undefined
							? OBJ["background"]
							: OBJ[ANIMATION_TYPE];
					observer.unobserve(entry.target);
				}
			},
			{
				// rootMargin: "-60px",
				threshold: 1,
			}
		);
		observer.observe(ref.current);
	}, [ref, ANIMATION_TYPE]);

	return <div ref={ref}>{children}</div>;
}

export default MainIntersectProvider;
